import React from "react";
import { DatePicker } from "@material-ui/pickers";
import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";

// @material-ui/pickers (DatePicker) se reutiliza en mas de 20 vistas de
// "facturacion" con el tema claro por defecto (InvoiceData, Retention,
// referralGhide, etc.). Para no afectarlas, este componente aplica un tema
// oscuro SOLO al DatePicker que envuelve, via un ThemeProvider anidado que
// no altera el tema global (los overrides aqui solo llegan a los
// componentes renderizados dentro de este arbol de React, aunque el
// calendario se abra en un modal). Uso exclusivo de sistemaContable.
const darkPickerTheme = (outerTheme) =>
  createMuiTheme(outerTheme, {
    overrides: {
      MuiPickersModal: {
        dialogRoot: {
          background: "#111a2b",
        },
      },
      MuiFormLabel: {
        root: {
          color: "#f5f7fb",
          "&$focused": {
            color: "#f5f7fb",
          },
        },
      },
      MuiInputLabel: {
        root: {
          color: "#f5f7fb",
        },
      },
      MuiInputBase: {
        root: {
          color: "#f5f7fb",
        },
        input: {
          color: "#f5f7fb",
        },
      },
      MuiOutlinedInput: {
        input: {
          color: "#f5f7fb",
        },
      },
      MuiPickersToolbar: {
        toolbar: {
          background: "#0d172b",
        },
      },
      MuiPickersToolbarText: {
        toolbarTxt: {
          color: "#8fb1d8",
        },
        toolbarBtnSelected: {
          color: "#ffffff",
        },
      },
      MuiPickersCalendarHeader: {
        switchHeader: {
          color: "#f5f7fb",
        },
        iconButton: {
          backgroundColor: "transparent",
          color: "#8fb1d8",
        },
        dayLabel: {
          color: "#53647e",
        },
      },
      MuiPickersDay: {
        day: {
          color: "#acd0f6",
        },
        daySelected: {
          backgroundColor: "#19b8f2",
          color: "#06101f",
          "&:hover": {
            backgroundColor: "#02dfb1",
          },
        },
        dayDisabled: {
          color: "#3a4a63",
        },
        current: {
          color: "#02dfb1",
        },
      },
      MuiPickersYear: {
        root: {
          color: "#acd0f6",
        },
        yearSelected: {
          color: "#19b8f2",
        },
      },
      MuiButton: {
        textPrimary: {
          color: "#19b8f2",
        },
      },
    },
  });

const DarkDatePicker = (props) => (
  <ThemeProvider theme={darkPickerTheme}>
    <DatePicker {...props} />
  </ThemeProvider>
);

export default DarkDatePicker;
